import cx from 'classnames';
import { StatusProps } from './Status.types';

const Status = ({ status, backgroundColour, textColour = 'text-neutral-50' }: StatusProps): JSX.Element => (
  <span
    className={cx(
      'inline-flex justify-center items-center text-center truncate rounded-full min-w-7.5 py-1 px-2.5 sub-header-sm',
      backgroundColour,
      textColour,
    )}
  >
    {status}
  </span>
);

export default Status;
